<template>
    <div class="dates targeting-block">
        <div class="title">
            <span>{{ label }}</span>
            <img
                v-if="!localPeriod.start || !localPeriod.end"
                alt="red_star"
                class="is-empty"
                src="/images/red_star.svg"
            />
        </div>
        <div class="input-data">
            <div class="date">
                <label>Дата запуска</label>
                <input
                    v-model="localPeriod.start"
                    @input="emitPeriod"
                    :min="getMinStartDate()"
                    :max="getMaxStartDate()"
                    type="date"
                    required
                />
            </div>
            <div class="date">
                <label>Дата окончания</label>
                <input
                    v-model="localPeriod.end"
                    @input="emitPeriod"
                    :min="getMinEndDate()"
                    :max="getMaxEndDate()"
                    type="date"
                    required
                />
            </div>
        </div>
    </div>
</template>

<script>
import { getRtbDateString } from '../../utils/timezones';

export default {
    name: 'Period',
    props: {
        label: {
            type: String,
            default: 'Название кампании',
        },
        period: {
            type: Object,
            default: () => ({ start: '', end: '' }),
        },
        minDate: {
            type: String,
            default: null,
        },
        maxDate: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            localPeriod: {
                start: this.period?.start || '',
                end: this.period?.end || '',
            },
        };
    },

    watch: {
        period: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    let start = newVal.start || '';
                    let end = newVal.end || '';
                    
                    // Ограничиваем даты периодом кампании, если он задан
                    if (this.minDate && start && start < this.minDate) {
                        start = this.minDate;
                    }
                    if (this.maxDate && end && end > this.maxDate) {
                        end = this.maxDate;
                    }
                    if (this.maxDate && start && start > this.maxDate) {
                        start = this.maxDate;
                    }
                    if (this.minDate && end && end < this.minDate) {
                        end = this.minDate;
                    }
                    
                    this.localPeriod = {
                        start: start,
                        end: end,
                    };
                    
                    // Если даты были скорректированы, отправляем обновление
                    if (start !== (newVal.start || '') || end !== (newVal.end || '')) {
                        this.$nextTick(() => {
                            this.emitPeriod();
                        });
                    }
                }
            },
        },
        minDate: {
            handler() {
                // При изменении минимальной даты проверяем текущие значения
                if (this.localPeriod.start && this.minDate && this.localPeriod.start < this.minDate) {
                    this.localPeriod.start = this.minDate;
                    this.emitPeriod();
                }
                if (this.localPeriod.end && this.minDate && this.localPeriod.end < this.minDate) {
                    this.localPeriod.end = this.minDate;
                    this.emitPeriod();
                }
            },
        },
        maxDate: {
            handler() {
                // При изменении максимальной даты проверяем текущие значения
                if (this.localPeriod.start && this.maxDate && this.localPeriod.start > this.maxDate) {
                    this.localPeriod.start = this.maxDate;
                    this.emitPeriod();
                }
                if (this.localPeriod.end && this.maxDate && this.localPeriod.end > this.maxDate) {
                    this.localPeriod.end = this.maxDate;
                    this.emitPeriod();
                }
            },
        },
    },
    methods: {
        emitPeriod() {
            this.$emit('update:period', { ...this.localPeriod });
        },
        getToday() {
            return getRtbDateString();
        },
        getMinStartDate() {
            // Минимальная дата начала - максимум из: сегодня, minDate (период кампании)
            const today = this.getToday();
            if (this.minDate) {
                return today > this.minDate ? today : this.minDate;
            }
            return today;
        },
        getMaxStartDate() {
            // Максимальная дата начала - минимум из: дата окончания объявления, maxDate (период кампании)
            if (this.maxDate && this.localPeriod.end) {
                return this.localPeriod.end < this.maxDate ? this.localPeriod.end : this.maxDate;
            }
            if (this.maxDate) {
                return this.maxDate;
            }
            return this.localPeriod.end || null;
        },
        getMinEndDate() {
            // Минимальная дата окончания - максимум из: дата начала объявления, minDate (период кампании)
            if (this.minDate && this.localPeriod.start) {
                return this.localPeriod.start > this.minDate ? this.localPeriod.start : this.minDate;
            }
            return this.localPeriod.start || null;
        },
        getMaxEndDate() {
            // Максимальная дата окончания - maxDate (период кампании)
            return this.maxDate || null;
        },
    },
};
</script>

<style lang="scss" scoped>
.date {
    display: flex;
    flex-direction: column;
    width: 45%;
}
</style>
